import React, { Component } from "react";
import { Table, Card, Row, Col, Button, Image } from "react-bootstrap";
import AddCurrency from "../Currency/AddCurrency";
import EditCurrency from "./EditCurrency";
import DeleteCurrency from "./DeleteCurrency";
import ReactPaginate from "react-paginate";
import "./Currency.css";

var dateFormat = require("dateformat");

class Currency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddModel: false,
      showEditModel: false,
      showDelModel: false,
      page: 0,
      perPage: 10,
    };
  }
  componentDidMount() {
    this.props.fetchCurrency();
    this.props.fetchCoutrys();
  }

  handleAddCurrency = () => {
    this.setState({
      showAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({ showAddModel: false });
  };
  handleEditCurrency = (item) => {
    this.setState({
      showEditModel: true,
      ItemList: item,
    });
  };
  closeEditModel = () => {
    this.setState({
      showEditModel: false,
    });
  };

  handleDelCountry = (item) => {
    this.setState({
      showDelModel: true,
      DeleteItem: item,
    });
  };
  closeDelModel = () => {
    this.setState({
      showDelModel: false,
    });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.currencySlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };
  render() {
    let p = this.state.page + 1;
    const count = this.props.currencyDtlsCount && this.props.currencyDtlsCount;
    let currencyPageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3> Currency</h3>
              </Col>

              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="currencyRecrd">
                  <i className="cui-note cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count ? count : 0}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Button
              style={{ marginBottom: "15px" }}
              onClick={() => this.handleAddCurrency()}
            >
              <i className="fa fa-plus fa-md"></i>
              <span style={{ marginLeft: "5px", fontWeight: "bold" }}>ADD</span>
            </Button>
            <AddCurrency
              showAddModel={this.state.showAddModel}
              closeAddModel={this.closeAddModel}
              AddCurrency={this.props.AddCurrency}
              CountrysList={this.props.CountrysList}
              resetPage={this.resetPage}
            />
            <Table responsive className="cmnMainTable" bordered striped>
              <thead>
                <tr className="cmnMainTableHd">
                  <th>Sl No</th>
                  <th>ISO 4217 Code</th>
                  <th> Name</th>
                  <th> Symbol</th>
                  <th> Subunit</th>
                  <th>Active</th>
                  <th>Created Date </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {this.props.CurrencyList &&
                  this.props.CurrencyList.map((item, i) => (
                    <tr key={i}>
                      <td>{10 * (p - 1) + i + 1}</td>
                      <td className="cmn_Cap">
                        {item !== null && item.iso4217Code}
                      </td>
                      <td className="cmn_Cap">{item !== null && item.name}</td>

                      <td className="cmn_Cap">
                        {item !== null && item.symbol}
                      </td>
                      <td className="cmn_Cap">
                        {item !== null && item.subunit}
                      </td>

                      <td className="cmn_Cap">
                        {item.isActive ? "Yes" : "No"}
                      </td>
                      <td className="cmn_Cap">
                        {item !== null &&
                          item.createdAt !== null &&
                          dateFormat(item.createdAt, "mediumDate")}
                      </td>
                      <td className="cmnViewIcon">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {" "}
                          <i
                            className="fa fa-edit fa-lg "
                            onClick={() => this.handleEditCurrency(item)}
                          ></i>
                          <EditCurrency
                            showEditModel={this.state.showEditModel}
                            closeEditModel={this.closeEditModel}
                            ItemList={this.state.ItemList}
                            EditCurrency={this.props.EditCurrency}
                            CountrysList={this.props.CountrysList}
                            resetPage={this.resetPage}
                          />
                          <i
                            className="fa fa-trash fa-lg"
                            style={{
                              paddingLeft: 10,
                            }}
                            onClick={() => this.handleDelCountry(item)}
                          ></i>
                          <DeleteCurrency
                            showDelModel={this.state.showDelModel}
                            closeDelModel={this.closeDelModel}
                            DeleteItem={this.state.DeleteItem}
                            DeleteCurrency={this.props.DeleteCurrency}
                            resetPage={this.resetPage}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            {(this.props.CurrencyList === undefined ||
              (this.props.CurrencyList &&
                this.props.CurrencyList.length === 0)) && (
              <div>
                <div className="noDataImgDiv">
                  <Image
                    className="noDataImg"
                    src={require("../../../assets/img/nodata4.png")}
                  />
                </div>
                <div className="noDataTextDiv">No Currencies Found</div>
              </div>
            )}
          </Card.Body>
          {currencyPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={currencyPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default Currency;
